(function () {
    'ngInject';

    angular.module('app.shared.services').factory('CustomilyFaceCutOutAPIService', CustomilyFaceCutOutAPIService);

    function CustomilyFaceCutOutAPIService() {
        const baseURL = `${process.env.VUE_APP_CUSTOMILY_FACE_CUT_API_URL}`;

        async function applyFilter(image) {
            const formData = new FormData();
            formData.append('imagefile', image);

            try {
                const response = await fetch(baseURL, {
                    method: 'POST',
                    body: formData
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                return await response.blob();
            } catch (error) {
                throw error;
            }
        }

        return {
            applyFilter
        };
    }
})();
